import markUrl from '../assets/saragossa-mark.svg';

interface AccessDeniedProps {
  reason: string;
  principal?: { displayName?: string; upn?: string };
}

export function AccessDenied({ reason, principal }: AccessDeniedProps) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg)' }}>
      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <img src={markUrl} alt="" className="brand-art" style={{ height: 56, width: 'auto', margin: '0 auto 32px', opacity: 0.6 }} draggable={false} />
        <h1 style={{ fontSize: 26, fontWeight: 500, letterSpacing: '-0.01em', marginBottom: 12 }}>No access</h1>
        <p style={{ color: 'var(--text-2)', lineHeight: 1.6 }}>{reason}</p>
        {principal?.upn && (
          <p style={{ color: 'var(--text-3)', fontSize: 12, marginTop: 28, fontFamily: 'var(--mono)' }}>
            Signed in as {principal.displayName ?? principal.upn}
          </p>
        )}
        <a href="/logout" className="ds-btn" style={{ marginTop: 20 }}>
          Sign out
        </a>
      </div>
    </div>
  );
}
